/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import AddressHelper from '../../OrderDetails/Helper/AddressHelper';
import { getFeatureFlags } from '../../../utils/featureSelectors';
import { isEmpty } from '../../../utils/object';

class DesktopShippingAddress extends React.Component {
    modifyOrders = () => {
        const { openMmo, itemDetailList, orderData } = this.props;
        openMmo('editAddress', itemDetailList, orderData);
    };

    render() {
        const { recipient, isPassport, featureFlags } = this.props;

        const ENABLE_MMO =        !isEmpty(featureFlags)
        && featureFlags['is-account-mmo-enabled'] === true;
        return (
            <>

                {isPassport ? (
                    <h2 className="gray-color">
                        Recipient:{' '}
                        <span className="normal bold body-color no-uppercase">
                            {recipient  && isPassport
                                ? `${recipient.firstName} ${recipient.lastName}`
                                : ''}
                        </span>
                    </h2>
                ) : (
                    <h2 className="gray-color">
                        <>
                            <div className="split align-center">
                                <div className="align-left">
                                    Shipping Address
                                </div>
                            </div>
                        </>
                    </h2>
                )}

                <div className={recipient.recipientEnable === 'true' && ENABLE_MMO ? 'margin-bottom min-height-100' : 'margin-bottom'}>
                    <div className="bold">
                        {recipient  && !isPassport
                            ? `${recipient.firstName} ${recipient.lastName}`
                            : ''}
                    </div>
                    {recipient && recipient.businessName && !isPassport ? (
                        <div>{recipient.businessName}</div>
                    ) : (
                        ''
                    )}
                    {recipient && recipient.address && !isPassport ? (
                        <AddressHelper
                            address={recipient.address}
                            phone={recipient.phone || {}}
                        />
                    ) : (
                        ''
                    )}
                </div>
                {recipient.recipientEnable === 'true' && ENABLE_MMO ? (
                    <Button
                        className="float-none secondary"
                        onClick={() => this.modifyOrders()}
                    >
                        Modify
                    </Button>
                ) : (
                    ''
                )}
            </>
        );
    }
}

DesktopShippingAddress.defaultProps = {
    isPassport: false,
    featureFlags: {},
};

DesktopShippingAddress.propTypes = {
    recipient: PropTypes.object.isRequired,
    isPassport: PropTypes.bool,
    featureFlags: PropTypes.object,
    itemDetailList: PropTypes.array.isRequired,
    orderData: PropTypes.object.isRequired,
    openMmo: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
    let featureFlags = {};
    if (state.app) {
        try {
            featureFlags = {
                ...getFeatureFlags(state),
            };
            // eslint-disable-next-line no-empty
        } catch (ex) {}
    }
    return {
        featureFlags,
    };
};

export default connect(
    mapStateToProps,
    null,
)(DesktopShippingAddress);
